<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Phân công giám thị</div>
    </div>
    <div class="d-flex justify-end align-center">
      <v-spacer></v-spacer>
      <v-btn color="primary" class="elevation-0 mb-6" dark @click="openCreate">
        <v-icon left>mdi-plus</v-icon>Phân công</v-btn
      >
    </div>
    <AssignMonitorForm :state="dialog" @closeDialog="close" @refresh="refresh" />

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <MonitorFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <MonitorTable ref="monitorTable" :query="query" :subjects="subjects" :rooms="rooms" :type="type" :grade="grade" />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import MonitorFilter from '@/modules/exam/MonitorFilter.vue'
import MonitorTable from '@/modules/exam/MonitorTable.vue'
import AssignMonitorForm from '@/modules/exam/AssignMonitorForm.vue'

export default {
  components: {
    MonitorFilter,
    MonitorTable,
    AssignMonitorForm,
    StudentBlankView
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subjects: [],
      rooms: [],
      query: {},
      type: '',
      grade: '',
      dialog: false
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, subjects, rooms, type, grade) {
      this.action.state = 'filtered'
      this.query = params
      this.subjects = subjects
      this.rooms = rooms
      this.type = type
      this.grade = grade
    },
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    remove(item) {
      this.item = item
      this.deleteDialog = true
    },
    openCreate() {
      this.dialog = true
    },
    refresh() {
      this.$refs.monitorTable.refresh()
    },
    openConfirm() {
      this.confirmDialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.refresh()
      this.updateDialog = false
    },
    closeDelete() {
      this.deleteDialog = false
    },
    closeConfirm() {
      this.confirmDialog = false
    }
  }
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
